import { render, staticRenderFns } from "./UserIndex.vue?vue&type=template&id=58fc99ac"
import script from "./UserIndex.vue?vue&type=script&lang=js"
export * from "./UserIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports